import * as React from 'react';
import { useSelector } from 'react-redux';
import { AnimatedContainer } from '../../components/AnimatedContainer';
import { HowItWorks, HowItWorksItem } from '../../components/LandingPageV2/HowItWorks';
import { selectIsAnimationAvailable } from '../../selectors/pageState';

const DEFAULT_ITEMS = [
  {
    step: '1',
    title: 'Вы\u00A0заполняете заявку',
    description: 'Или\u00A0звоните нам\u00A0— консультант уточнит всё\u00A0необходимое',
  },
  {
    step: '2',
    title: 'Мы\u00A0уточняем, о\u00A0каком жильё вы\u00A0мечтаете',
  },
  {
    step: '3',
    title: 'Подбираем квартиры в\u00A0новостройках',
    description:
      'Пришлём варианты, которые подойдут именно вам: с\u00A0необычной планировкой, у\u00A0парка или\u00A0рядом со\u00A0школой',
  },
  {
    step: '4',
    title: 'Если\u00A0понравилась квартира — помогаем её\u00A0забронировать',
  },
  {
    step: '5',
    title: 'Готовимся к\u00A0сделке вместе',
    description: 'Посоветуем\u00A0ипотечную программу, проверим договор и\u00A0поможем с\u00A0документами',
  },
];

export const HowItWorksContainer: React.FC = () => {
  const isAnimationAvailable = useSelector(selectIsAnimationAvailable);

  return (
    <HowItWorks>
      {DEFAULT_ITEMS.map((item, index) => (
        <AnimatedContainer key={item.title} isAnimationAvailable={isAnimationAvailable}>
          <HowItWorksItem key={item.title} isLtr={(index + 1) % 2 === 0} {...item} />
        </AnimatedContainer>
      ))}
    </HowItWorks>
  );
};
